/* pipiu PDP — bundle picker (1/2/3 pairs, each pair has own Color + Size), gallery, cart */
(function () {
  if (customElements.get('pipiu-pdp')) return;

  const fmt = (c) => '$' + (c / 100).toFixed(2);
  const fmtShort = (c) => (c % 100 === 0 ? '$' + c / 100 : fmt(c));

  class PipiuPdp extends HTMLElement {
    connectedCallback() {
      if (this._init) return;
      this._init = true;
      try {
        this.cfg = JSON.parse(this.querySelector('[data-pp-config]').textContent);
      } catch (e) {
        console.error('[pipiu-pdp] bad config', e);
        return;
      }
      this.qty = 1;
      this.img = 0;
      this.pairs = Array.from(this.querySelectorAll('[data-pp-pair]'));
      this.sel = this.pairs.map((fs) => {
        const c = fs.querySelector('[data-pp-color][aria-pressed="true"]');
        return { color: c ? c.dataset.ppColor : null, size: null };
      });
      this.bind();
      this.render();
    }

    $(s) { return this.querySelector(s); }
    $$(s) { return Array.from(this.querySelectorAll(s)); }

    bind() {
      // offers
      this.$$('[data-pp-qty]').forEach((b) =>
        b.addEventListener('click', () => { this.qty = +b.dataset.ppQty; this.setErr(''); this.render(); })
      );
      // nudge
      this.$('[data-pp-nudge]')?.addEventListener('click', (e) => { const nx = +e.currentTarget.dataset.next; if (nx) { this.qty = nx; this.setErr(''); this.render(); } });
      // pairs
      this.pairs.forEach((fs, i) => {
        fs.querySelectorAll('[data-pp-color]').forEach((b) =>
          b.addEventListener('click', () => {
            this.sel[i].color = b.dataset.ppColor;
            this.setErr('');
            this.render();
            const v = this.findVariant(this.sel[i].color, this.sel[i].size) || this.findVariant(this.sel[i].color, null);
            if (v && v.media) this.showMediaId(v.media);
          })
        );
        fs.querySelectorAll('[data-pp-size]').forEach((b) =>
          b.addEventListener('click', () => {
            if (b.disabled) return;
            this.sel[i].size = b.dataset.ppSize;
            this.setErr('');
            this.render();
          })
        );
      });
      // gallery
      const n = this.cfg.media.length;
      this.$('[data-pp-prev]')?.addEventListener('click', () => this.showImg((this.img - 1 + n) % n));
      this.$('[data-pp-next]')?.addEventListener('click', () => this.showImg((this.img + 1) % n));
      this.$$('[data-pp-thumb]').forEach((b) => b.addEventListener('click', () => this.showImg(+b.dataset.ppThumb)));
      // modals
      this.sizeModal = this.$('[data-pp-size-modal]');
      this.lightbox = this.$('[data-pp-lightbox]');
      [this.sizeModal, this.lightbox].forEach((m) => {
        if (!m) return;
        document.body.appendChild(m); // escape stacking contexts
        m.addEventListener('click', (e) => { if (e.target === m || e.target.closest('[data-pp-close]')) this.closeModal(m); });
      });
      this.$$('[data-pp-open-size]').forEach((b) => b.addEventListener('click', () => this.openModal(this.sizeModal)));
      this.$('[data-pp-zoom]')?.addEventListener('click', () => {
        const m = this.cfg.media[this.img];
        if (!m || !this.lightbox) return;
        const im = this.lightbox.querySelector('[data-pp-lightbox-img]');
        im.src = m.src; im.alt = m.alt;
        this.openModal(this.lightbox);
      });
      document.addEventListener('keydown', (e) => {
        if (e.key === 'Escape') [this.sizeModal, this.lightbox].forEach((m) => m && this.closeModal(m));
      });
      // add to cart (main + sticky)
      this.$$('[data-pp-add]').forEach((b) => b.addEventListener('click', () => this.addToCart(b)));
      // sticky observer
      this.sticky = this.$('[data-pp-sticky]');
      const mainCta = this.$('.pp-info [data-pp-add]');
      if (this.sticky) {
        document.body.appendChild(this.sticky);
        if (mainCta && 'IntersectionObserver' in window) {
          new IntersectionObserver(([e]) => {
            const passed = !e.isIntersecting && e.boundingClientRect.top < 0;
            this.sticky.toggleAttribute('data-show', passed);
            document.body.style.paddingBottom = passed && window.innerWidth < 900 ? '80px' : '';
          }).observe(mainCta);
        }
      }
    }

    openModal(m) { if (m) { m.setAttribute('data-open', ''); document.documentElement.style.overflow = 'hidden'; } }
    closeModal(m) { if (m && m.hasAttribute('data-open')) { m.removeAttribute('data-open'); document.documentElement.style.overflow = ''; } }

    showImg(i) {
      const m = this.cfg.media[i];
      if (!m) return;
      this.img = i;
      const main = this.$('[data-pp-main]');
      if (main) { main.src = m.src; main.alt = m.alt; main.removeAttribute('srcset'); }
      const cap = this.$('[data-pp-caption]'); if (cap) cap.textContent = m.alt;
      const cnt = this.$('[data-pp-counter]'); if (cnt) cnt.textContent = i + 1 + ' / ' + this.cfg.media.length;
      this.$$('[data-pp-thumb]').forEach((t) => t.setAttribute('aria-pressed', String(+t.dataset.ppThumb === i)));
    }
    showMediaId(id) {
      const i = this.cfg.media.findIndex((m) => m.id === id);
      if (i >= 0) this.showImg(i);
    }

    findVariant(color, size) {
      const cp = this.cfg.colorPos - 1, sp = this.cfg.sizePos - 1;
      return this.cfg.variants.find((v) =>
        (cp < 0 || color == null || v.options[cp] === color) &&
        (sp < 0 || size == null || v.options[sp] === size)
      );
    }

    tier(n) { return this.cfg.tiers[String(Math.min(n, 3))]; }

    setErr(t) { const e = this.$('[data-pp-err]'); if (e) e.textContent = t; }

    render() {
      const q = this.qty, per = this.tier(q), total = per * q, full = this.cfg.compare * q, save = full - total;
      const pct = full > 0 ? Math.round((save / full) * 100) : 0;
      // price
      [this, this.sticky].forEach((root) => root && root.querySelectorAll('[data-pp-total]').forEach((el) => (el.textContent = fmt(total))));
      [this, this.sticky].forEach((root) => root && root.querySelectorAll('[data-pp-compare]').forEach((el) => (el.textContent = fmt(full))));
      const sv = this.$('[data-pp-save]');
      if (sv) { sv.textContent = save > 0 ? 'Save ' + fmtShort(save) + ' (' + pct + '% OFF)' : ''; sv.hidden = save <= 0; }
      const unit = this.$('[data-pp-unit]');
      if (unit) unit.textContent = q + (q === 1 ? ' pair' : ' pairs') + ' · ' + fmt(per) + ' per pair · USD';
      // offers
      this.$$('[data-pp-qty]').forEach((b) => {
        const n = +b.dataset.ppQty, p = this.tier(n);
        b.setAttribute('aria-pressed', String(n === q));
        const perEl = b.querySelector('[data-pp-per]'); if (perEl) perEl.textContent = fmtShort(p);
        const s = n * (this.cfg.compare - p);
        const se = b.querySelector('[data-pp-offer-save]');
        if (se) { se.textContent = s > 0 ? 'Save ' + fmtShort(s) : ''; se.hidden = s <= 0; }
        const oe = b.querySelector('[data-pp-off]');
        if (oe) { const op = Math.round((s / (n * this.cfg.compare)) * 100); oe.textContent = op + '% OFF'; oe.hidden = op <= 0; }
      });
      // upsell nudge
      const ng = this.$('[data-pp-nudge]');
      if (ng) {
        const nextQ = q < 3 ? q + 1 : 0;
        if (nextQ) {
          const extra = this.tier(nextQ) * nextQ - per * q;
          const offN = Math.round((1 - this.tier(nextQ) / this.cfg.compare) * 100);
          ng.innerHTML = 'Add a ' + (nextQ === 2 ? '2nd' : '3rd') + ' pair for just <b>' + fmtShort(extra) + ' more</b> &middot; ' + offN + '% OFF every pair <span aria-hidden="true">&rarr;</span>';
          ng.dataset.next = String(nextQ);
          ng.classList.remove('is-done');
        } else {
          ng.innerHTML = '<b>Lowest price unlocked:</b> ' + fmtShort(per) + ' per pair &middot; ' + pct + '% OFF';
          ng.dataset.next = '';
          ng.classList.add('is-done');
        }
        ng.hidden = false;
      }
      // pairs
      this.pairs.forEach((fs, i) => {
        fs.hidden = i >= q;
        const lg = fs.querySelector('[data-pp-legend]');
        if (lg) lg.textContent = q > 1 ? 'Pair ' + (i + 1) : 'Choose your options';
        const s = this.sel[i];
        const cl = fs.querySelector('[data-pp-color-label]'); if (cl && s.color) cl.textContent = s.color;
        fs.querySelectorAll('[data-pp-color]').forEach((b) => b.setAttribute('aria-pressed', String(b.dataset.ppColor === s.color)));
        fs.querySelectorAll('[data-pp-size]').forEach((b) => {
          const v = this.findVariant(s.color, b.dataset.ppSize);
          const ok = !!(v && v.available);
          b.disabled = !ok;
          if (!ok && s.size === b.dataset.ppSize) s.size = null;
          b.setAttribute('aria-pressed', String(b.dataset.ppSize === s.size));
        });
      });
      // CTA
      const label = (this.cfg.ctaText || 'Add to Cart') + ' · ' + fmt(total);
      [this, this.sticky].forEach((root) => root && root.querySelectorAll('[data-pp-add]').forEach((b) => (b.textContent = label)));
    }

    async addToCart(btn) {
      const q = this.qty;
      const miss = this.sel.slice(0, q).findIndex((x) => !x.size);
      if (miss >= 0) {
        this.setErr('Please choose a size for ' + (q === 1 ? 'your pair.' : 'pair ' + (miss + 1) + '.'));
        const fs = this.pairs[miss];
        if (fs) window.scrollTo({ top: fs.getBoundingClientRect().top + window.scrollY - 110, behavior: 'smooth' });
        return;
      }
      const counts = new Map();
      for (const s of this.sel.slice(0, q)) {
        const v = this.findVariant(s.color, s.size);
        if (!v) { this.setErr('That combination is unavailable. Please pick another size or color.'); return; }
        counts.set(v.id, (counts.get(v.id) || 0) + 1);
      }
      const items = Array.from(counts, ([id, quantity]) => ({ id, quantity }));
      const drawer = document.querySelector('sugar-cart-drawer');
      const body = { items };
      if (drawer && typeof drawer.renderContents === 'function') {
        body.sections = 'sugar-cart-drawer,cart-icon-bubble';
        body.sections_url = window.location.pathname;
      }
      const btns = [this, this.sticky].flatMap((r) => (r ? Array.from(r.querySelectorAll('[data-pp-add]')) : []));
      btns.forEach((b) => b.setAttribute('aria-busy', 'true'));
      try {
        const res = await fetch((this.cfg.addUrl || '/cart/add') + '.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify(body),
        });
        const data = await res.json();
        if (!res.ok || data.status) throw new Error(data.description || data.message || 'Could not add to cart');
        this.setErr('');
        if (drawer && typeof drawer.renderContents === 'function' && data.sections) {
          try {
            drawer.renderContents(data);
            if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
              publish(PUB_SUB_EVENTS.cartUpdate, { source: 'product-form', cartData: data });
            }
            return;
          } catch (e) { console.warn('[pipiu-pdp] drawer render failed', e); }
        }
        window.location.href = this.cfg.cartUrl || '/cart';
      } catch (e) {
        this.setErr(e.message || 'Something went wrong. Please try again.');
      } finally {
        btns.forEach((b) => b.removeAttribute('aria-busy'));
      }
    }
  }

  customElements.define('pipiu-pdp', PipiuPdp);

  /* rotating review quotes (under product description) */
  function initQuotes(root) {
    (root || document).querySelectorAll('[data-pp-quotes]').forEach((box) => {
      if (box._ppq) return; box._ppq = true;
      const slides = Array.from(box.querySelectorAll('[data-pp-quote]'));
      if (!slides.length) return;
      const dotsWrap = box.querySelector('[data-pp-quote-dots]');
      let i = 0, timer = null, paused = false;
      const ms = Math.max(2, parseFloat(box.dataset.interval) || 2) * 1000;
      const dots = slides.length > 1 && dotsWrap ? slides.map((_, k) => { const d = document.createElement('span'); d.className = 'pp-quote__dot'; dotsWrap.appendChild(d); return d; }) : [];
      const show = (n) => {
        i = (n + slides.length) % slides.length;
        slides.forEach((s, k) => { s.classList.toggle('is-active', k === i); s.setAttribute('aria-hidden', String(k !== i)); });
        dots.forEach((d, k) => d.classList.toggle('is-active', k === i));
      };
      show(0);
      if (slides.length < 2) return;
      const start = () => { clearInterval(timer); timer = setInterval(() => { if (!paused && !document.hidden) show(i + 1); }, ms); };
      box.addEventListener('mouseenter', () => (paused = true));
      box.addEventListener('mouseleave', () => (paused = false));
      box.addEventListener('focusin', () => (paused = true));
      box.addEventListener('focusout', () => (paused = false));
      box.addEventListener('touchstart', () => { paused = true; clearTimeout(box._ppqt); box._ppqt = setTimeout(() => (paused = false), 5000); }, { passive: true });
      start();
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initQuotes()); else initQuotes();
  document.addEventListener('shopify:section:load', (e) => initQuotes(e.target));
})();
